module.exports = __webpack_public_path__ + "static/img/23(1).584f730.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/23(1).png
// module id = QFFr
// module chunks = 0